import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { elRed, textPrimary, dropdownBackground } from 'src/styles/colors';

const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  background: none;
  border: none;
  font: inherit;
  color: inherit;
  cursor: pointer;
  white-space: nowrap;
`;

const Panel = styled.div`
  position: absolute;
  top: 100%;
  ${({ $alignRight }) => $alignRight ? 'right: 0;' : 'left: -10px;'}
  margin-top: 8px;
  min-width: 220px;
  width: max-content;
  display: flex;
  flex-direction: column;
  z-index: 9999;
  color: ${textPrimary};
  background-color: ${dropdownBackground};
  border: 1px solid ${elRed};
  border-radius: 6px;
`;

export const DropdownChevron = ({ isOpen }) => (
  <FontAwesomeIcon
    icon={isOpen ? faChevronUp : faChevronDown}
    size='sm'
    style={{ color: elRed }}
  />
);

const NavigationDropdown = ({
  trigger, isOpen, onToggle, alignRight, showChevron = true, ariaLabel,
  children,
}) => (
  <Wrapper>
    <TriggerButton
      type="button"
      onClick={onToggle}
      aria-expanded={isOpen}
      aria-haspopup="true"
      aria-label={ariaLabel}
    >
      {trigger}
      {showChevron && <DropdownChevron isOpen={isOpen} />}
    </TriggerButton>
    {isOpen &&
      <Panel $alignRight={alignRight}>
        {children}
      </Panel>
    }
  </Wrapper>
);

export default NavigationDropdown;
